var gradients = {};
export { gradients };